/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import ReactPlayer from 'react-player';
import { useNavigate, useLocation } from 'react-router-dom';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import messages from 'src/shared/app/topic/new/l10n/newTopicNotificationL10n';

import styles from './NewTopicNotificationFirstLogin.style';
import {
  homeRoute,
  newTopicRoute,
} from 'src/shared/app/base/route/setting/routeSettings';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import NewTopicNotificationModal from './NewTopicNotificationModal';
import { getNotificationData } from 'src/shared/app/notification/util/notificationUtil';
import { NEW_TOPICS_MODAL } from 'src/shared/app/topic/new/constant/newTopicConstants';
import useWhatIsBraindateURL from 'src/shared/app/topic/new/hook/useWhatIsBraindateURL';
import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';

const useStyles = createUseThemeStyles(styles);

type Props = {
  notification?: Notification<>,
  onDismiss: () => void,
};

const NewTopicNotificationFirstLogin = ({
  notification,
  onDismiss,
}: Props): React.Node => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const data = notification && getNotificationData(notification);
  const isMarketNotEmpty = data && data.type === NEW_TOPICS_MODAL.FIRST_LOGIN;
  const videoURL = useWhatIsBraindateURL();
  const { isAccessibilityCompatibleEnabled } = useFeatureDecisions();
  const classes = useStyles();

  const [homePath, newTopicPath] = useRoutes(homeRoute, newTopicRoute);

  const handleAccept = () => {
    navigate(newTopicPath);
  };

  const handleClose = () => {
    if (location.pathname !== homePath) {
      navigate(homePath);
    }
    if (onDismiss) {
      onDismiss();
    }
  };
  const videoFirstLogin = !isAccessibilityCompatibleEnabled && (
    <div className={classes.playerWrapper}>
      <ReactPlayer
        className={classes.player}
        url={videoURL}
        width="100%"
        height="100%"
        controls
      />
    </div>
  );

  return (
    <NewTopicNotificationModal
      notification={notification}
      title={intl.formatMessage(messages.firstLoginTitle)}
      subtitle={intl.formatMessage(messages.firstLoginSubtitle)}
      content={intl.formatMessage(messages.firstLoginContent)}
      image={videoFirstLogin}
      acceptCTA={intl.formatMessage(messages.addTopic)}
      closeCTA={intl.formatMessage(
        isMarketNotEmpty ? messages.browse : messages.later,
      )}
      onAccept={handleAccept}
      onDismiss={handleClose}
    />
  );
};

export default React.memo<Props>(NewTopicNotificationFirstLogin);
